import { ReportHubDiagnosticAssessmentTotalQuery$variables } from '../graphQLOperations/__generated__/ReportHubDiagnosticAssessmentTotalQuery.graphql';
import { ReportHubOutstandingAssessmentsTotalQuery$variables } from '../graphQLOperations/__generated__/ReportHubOutstandingAssessmentsTotalQuery.graphql';
import { ReportHubSkillAssessmentsTotalQuery$variables } from '../graphQLOperations/__generated__/ReportHubSkillAssessmentsTotalQuery.graphql';
import { ReportData, ReportSubtype } from '../models/Report';

export const loadReportHubQuery = (
  subtype: ReportSubtype,
  loadQuery: (
    v:
      | ReportHubDiagnosticAssessmentTotalQuery$variables
      | ReportHubSkillAssessmentsTotalQuery$variables
      | ReportHubOutstandingAssessmentsTotalQuery$variables,
  ) => void,
  values: ReportData,
) => {
  switch (subtype) {
    case ReportSubtype.DIAGNOSTIC_SUMMARY:
      loadQuery({
        filter: values.roadmap ? { targetGroupIds: [values.roadmap] } : {},
      });
      break;
    case ReportSubtype.PROGRESS_SKILL_ASSESSMENT_HISTORY:
      loadQuery({
        filter: {
          targetGroupIds: values.roadmap ? [values.roadmap] : [],
          classIds: values.classes ? values.classes : [],
        },
      });
      break;
    case ReportSubtype.DIAGNOSTIC_STUDENTS_UNFINISHED_DIAGNOSTIC:
      loadQuery({
        filter: {
          onlyWithOutstandingDiagnostic: true,
          classIds: values.classes ? values.classes : [],
        },
      });
      break;

    default:
      console.warn('Unknown subtype:', subtype);
  }
};
